import { trace } from "@opentelemetry/api";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { resourceFromAttributes } from "@opentelemetry/resources";
import {
  BatchSpanProcessor,
  WebTracerProvider,
} from "@opentelemetry/sdk-trace-web";
import { ATTR_SERVICE_NAME } from "@opentelemetry/semantic-conventions";

let provider = null;
let tracer = null;

function getTracer() {
  if (tracer) return tracer;

  const apiKey = process.env.REACT_APP_HONEYCOMB_API_KEY;
  if (!apiKey) {
    return null;
  }

  const exporter = new OTLPTraceExporter({
    url: "https://api.honeycomb.io/v1/traces",
    headers: {
      "x-honeycomb-team": apiKey,
    },
  });

  provider = new WebTracerProvider({
    resource: resourceFromAttributes({
      [ATTR_SERVICE_NAME]: "kick-home-frontend",
    }),
    spanProcessors: [new BatchSpanProcessor(exporter)],
  });

  provider.register();
  tracer = trace.getTracer("signup-funnel");
  return tracer;
}

export function trackSignupEvent(eventName, attributes = {}) {
  const t = getTracer();
  if (!t) return;

  const span = t.startSpan(eventName);
  Object.entries(attributes).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      span.setAttribute(key, String(value));
    }
  });
  span.end();
}
